import { getBaseUrl } from '@/utils/urlUtils';
import { locationCategories } from '../../data/autocomplete/Location';

export const categoryTranslationsMap = {
  [locationCategories.city]: 'autocomplete.city',
  [locationCategories.region]: 'autocomplete.region',
  [locationCategories.subRegion]: 'autocomplete.sub_region',
  [locationCategories.country]: 'autocomplete.country',
};

// encode text into url safe
// ex: 'My text' -> 'My%20text'
const toURLSafe = text => encodeURIComponent(text);

const toURLArray = (searchAction, queryParamKey, arr) =>
  `${ searchAction }#${ arr.map(value => queryParamKey + '[]=' + toURLSafe(value)).join('&') }`;

const locationURLMap = searchAction => ({
  [locationCategories.city]: ({ label }) => searchAction + '#sblFilterValue=' + toURLSafe(label),
  [locationCategories.region]: ({ locationCode }) => toURLArray(searchAction, 'filter.region', locationCode),
  [locationCategories.subRegion]: ({ locationCode }) => toURLArray(searchAction, 'filter.sub_region', locationCode),
  [locationCategories.country]: ({ locationCode }) => toURLArray(searchAction, 'filter.country', locationCode),
});

const sblLocationURLMap = (searchAction, translate) => {
  const getSblValues = (locationType, label) => {
    return '&sblFilterValue=' + toURLSafe(`${ label } - ${ translate(categoryTranslationsMap[locationType]) }`);
  };

  return {
    [locationCategories.city]: ({ locationCode, label }) =>
      searchAction + `#filter.coordinates=${ locationCode }` + getSblValues(locationCategories.city, label),
    [locationCategories.region]: ({ locationCode, label }) =>
      toURLArray(searchAction, 'filter.region', locationCode) + getSblValues(locationCategories.region, label),
    [locationCategories.subRegion]: ({ locationCode, label }) =>
      toURLArray(searchAction, 'filter.sub_region', locationCode) + getSblValues(locationCategories.subRegion, label),
    [locationCategories.country]: ({ locationCode, label }) =>
      toURLArray(searchAction, 'filter.country', locationCode) + getSblValues(locationCategories.country, label),
  };
};

export function locationURLBuilder(searchAction, item, searchByLocationEnabled, translate) {
  const locationMapper = searchByLocationEnabled ? sblLocationURLMap(searchAction, translate) : locationURLMap(searchAction);
  if (!locationMapper[item.category]) throw new Error('invalid category');

  return locationMapper[item.category](item);
}

export const popularSearchURLBuilder = (searchAction, url) => {
  if (url.type === 'text') {
    return getBaseUrl(searchAction) + '#text=' + toURLSafe(url.value);
  } else {
    return getBaseUrl(searchAction) + url.value;
  }
};
export const ourSelectionURLBuilder = (searchAction, url) => getBaseUrl(searchAction) + url;
